import React from 'react';
import RadioButton, { IRadioButton } from '../RadioButton/RadioButton';
import {
   LabeledRadioButtonContainer,
   LabeledRadioButtonLabel,
   LabeledRadioButtonLabelWrapper,
   LabeledRadioButtonSublabel,
   LabeledRadioButtonWrapper
} from './LabeledRadioButton.styled';

export interface ILabeledRadioButton extends IRadioButton {
   label: string;
   sublabel?: string;
}

const LabeledRadioButton: React.FC<ILabeledRadioButton> = props => {
   const { label, sublabel, callback, disabled, value, groupName, readOnly } = props;

   return (
      <LabeledRadioButtonWrapper
         onClick={
            !disabled
               ? e => {
                    e.stopPropagation();
                    callback();
                 }
               : null
         }
      >
         <LabeledRadioButtonContainer flexDirection='row' spaceBetween={8}>
            <RadioButton {...props} />
            <LabeledRadioButtonLabelWrapper
               onClick={
                  disabled
                     ? e => {
                          e.stopPropagation();
                          callback();
                       }
                     : null
               }
            >
               <LabeledRadioButtonLabel size='m' weight='black'>
                  {label}
               </LabeledRadioButtonLabel>
            </LabeledRadioButtonLabelWrapper>
            {sublabel && (
               <LabeledRadioButtonSublabel size='s' weight='medium'>
                  {sublabel}
               </LabeledRadioButtonSublabel>
            )}
         </LabeledRadioButtonContainer>
      </LabeledRadioButtonWrapper>
   );
};

export default LabeledRadioButton;
